<template>
	<div class="tc-chart-content">
		<TCChartRow 
			v-bind:item="item"
			v-bind:isParent="true"
			v-bind:isEditable="isEditable"
			v-bind:isExpanded="isExpanded"
			v-bind:ghost_schedule="ghost_schedule"
			v-bind:bar_editing="bar_editing"
			v-on:bar-move-start="barMoveStart"
			v-on:request-ghost-schedule="onRequestGhostSchedule"
			v-on:bar-stretch-start="barStretchStart"
			v-on:hscroll-stop="onHScrollStop"
			v-on:update_schedule_info="updateScheduleInfo" />
		<TransitionExpand>
			<div v-if="isExpanded">
				<TCChartRow 
					v-for="child in item.children"
					v-bind:key="child.code"
					v-bind:item="child"
					v-bind:isParent="false"
					v-bind:isEditable="isEditable"
					v-bind:isExpanded="isExpanded"
					v-bind:ghost_schedule="ghost_schedule"
					v-bind:bar_editing="bar_editing"
					v-on:bar-move-start="barMoveStart"
					v-on:request-ghost-schedule="onRequestGhostSchedule"
					v-on:bar-stretch-start="barStretchStart"
					v-on:hscroll-stop="onHScrollStop"
					v-on:update_schedule_info="updateScheduleInfo"/>
			</div>
		</TransitionExpand>
	</div>
</template>
<script>
import TCChartRow from './TCChartRow';
import TransitionExpand from './TransitionExpand';

export default {
	name: 'TCChartContent',
	components: {
		TCChartRow,
		TransitionExpand,
	},
	props: [
		"item",
		"isEditable",
		"ghost_schedule",
		"bar_editing",
	],
	computed: {
		isExpanded: function() {
			return this.$store.getters['chart/isExpandedScheduleListRow'](this.item);
		},
	},
	methods: {
		barMoveStart: function(e) {
			this.$emit('bar-move-start', e);
		},
		barStretchStart: function(e) {
			this.$emit('bar-stretch-start', e);
		},
		updateScheduleInfo: function(e) {
			this.$emit('update_schedule_info', e);
		},
		onRequestGhostSchedule: function(e) {
			this.$emit("request-ghost-schedule", e);
		},
		onHScrollStop: function(e) {
			this.$emit('hscroll-stop', e);
		},
	},
}
</script>
<style>
	.tc-chart-content {
		border-bottom: 2px solid #a9a9a9;
	}
</style>
